// extracted by mini-css-extract-plugin
export default {"userManagement":"styles_userManagement__6giiK"};